module.exports = __webpack_public_path__ + "assets/images/plan_bg-d60bf25d6901fc385d28c209e1e2014c.jpg";